import $http from "@/services/Http";
import { responseToClass } from "@/api/lib";
import User from "@/models/User";
import { AxiosPromise } from "axios";
import { prefix } from "@/api/config";

export function me(): AxiosPromise<User> {
  return $http
    .get(`${prefix}/auth/me`)
    .then((response) => responseToClass(User, response));
}
